export enum ButtonAction {
  Button = 1,
  Submit = 2
}